import React, { Fragment, useEffect } from "react";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { fetchTaskListDetails } from "../actions/task";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const TaskDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // breadcrumb
  const translateModule = "tasks";
  const pageType = "ListDetails";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { taskDetailList } = useSelector((state) => state.taskReducer);

  useEffect(() => {
    dispatch(fetchTaskListDetails(id));
  }, [id]);

  // settings za tabelu
  const columnDefs = [
    {
      headerName: t("taskDetailTable.firstName"), // Prevod za "Ime"
      field: "accountName",
      filter: "agTextColumnFilter",
      width: 150,
    },
    {
      headerName: t("taskDetailTable.lastName"), // Prevod za "Prezime"
      field: "accountLastName",
      filter: "agTextColumnFilter",
      width: 150,
    },
    {
      headerName: t("taskDetailTable.company"), // Prevod za "Kompanija"
      field: "companyName",
      filter: "agSetColumnFilter",
    },
    {
      headerName: t("taskDetailTable.store"), // Prevod za "Radnja"
      field: "storeName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("taskDetailTable.referenceName"), // Prevod za "Naziv stavke zadatka"
      field: "referenceName",
      filter: "agTextColumnFilter",
      minWidth: 250,
      flex: 1,
      valueGetter: (params) => {
        if (params.data && params.data.referenceName) {
          return params.data.referenceName;
        }
        if (!params.data) {
          return ""; // ili neka vrednost za group row
        }
        return t("taskAdd.experienceTask");
      },
    },
    {
      headerName: t("taskDetailTable.goalName"), // Prevod za "Ostvareno"
      field: "goalName",
      filter: "agTextColumnFilter",
      width: 150,
    },
    {
      headerName: t("taskDetailTable.goal"), // Prevod za "Zadatak"
      field: "goal",
      filter: "agTextColumnFilter",
      width: 120,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={taskDetailList}
        columnDefs={columnDefs}
        gridStateKey={"task-detail-list"}
      />
    </Fragment>
  );
};

export default TaskDetail;
